import * as moment from 'moment';
import * as _ from "lodash";
import { useMemo, useState } from 'react';
import { BodyScrollEvent, CellClickedEvent, ColDef, FirstDataRenderedEvent, GridReadyEvent, GridSizeChangedEvent, ICellRendererParams, IHeaderParams, RowDataChangedEvent, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from '@nkr/components/ag-grid/default-style';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { ISwabShipmentOrder, useSwabShipmentOrderApi } from '@nkr/models/hla/swab-shipment-order';

interface IProps {
    batchId : number,
}

export const SwabShipmentOrderGrid = (props: IProps) => {
    const [menuDisplayed, setMenuDisplayed] = useState(false);

    const api               = useSwabShipmentOrderApi();
    const response          = api.useSearch({ batchId: props.batchId });
    const orders            = response?.payload || [];

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    }

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onBodyScroll = (e: BodyScrollEvent) => {
        if (menuDisplayed) {
            document.body.click();
            setMenuDisplayed(false);
        }
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        e.api.setColumnDefs(getColumnChanges());
        e.api.sizeColumnsToFit();
    };

    const handleMenuToggle = (show: boolean) => {
        setMenuDisplayed(show);
    };

    const getColumnChanges = () => {
        let cols: ColDef[] = [
            {
                colId: '1',
                field: 'rank',
                headerName: 'R#',
                headerComponentFramework: (params: IHeaderParams) => <div>R#</div>,
                sortable: false,
                width: 30,
                pinned: 'left',
                pinnedRowCellRendererFramework: () => <div></div>,
                valueGetter: (params: ValueGetterParams) => params.node?.rowIndex! + 1
            },
            {
                field: 'entityTypeDescription',
                headerName: 'Type',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Type</SortableHeaderComponent>,
                width: 130,
                sortable: true
            },
            {
                field: 'orderDate',
                headerName: 'Order Date',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Order Date</SortableHeaderComponent>,
                width: 130,
                sortable: true,
            },
            {
                field: 'firstName',
                headerName: 'firstName',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>First Name</SortableHeaderComponent>,
                width: 130,
                sortable: true,
            },
            {
                field: 'lastName',
                headerName: 'lastName',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Last Name</SortableHeaderComponent>,
                width: 130,
                sortable: true,
            },
            {
                field: 'city',
                headerName: 'city',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>City</SortableHeaderComponent>,
                width: 130,
                sortable: true,
            },
            {
                field: 'stateProvince',
                headerName: 'stateProvince',
                headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>State/Province</SortableHeaderComponent>,
                width: 130,
                sortable: true,
            },
        ]
        return cols;
    };

    const columnDefs    = useMemo(() => getColumnChanges(), []);
    const rowData       = useMemo(() => orders, [orders]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ height: '200px' }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={30}
                rowHeight={34}
                enableCellChangeFlash={true}
                suppressCellSelection={true}
                suppressMultiSort={true}
                rowStyle={{ overflow: 'visible' }}
                noRowsOverlayComponentFramework={() => <div>...</div>}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                onFirstDataRendered={onFirstDataRendered}
                onBodyScroll={onBodyScroll}
                onSortChanged={(e: SortChangedEvent) => e.api.refreshCells()}
            />
        </GridWrapper>
    )
}